<div class="m-search-result-list"
	 data-t-name="SearchResultList">
	<ng-container *ngIf="hasResults(); else  noResults">
		<div class="m-search-result-list__item"
			 *ngFor="let result of resultTab.results; trackBy: trackResultBy">
			<div class="m-search-result-list__type">
				<span class="m-search-result-list__type-item" [innerHTML]="result.typeLabel"></span>
				<span *ngIf="result.topParentLabel" class="m-search-result-list__type-item" [innerHTML]="result.topParentLabel"></span>
			</div>
			<cov-link class="m-search-result-list__title"
					  [class]="result.title.class"
					  [text]="result.title.text"
					  [href]="result.title.href"
					  [target]="result.title.target"
					  [rel]="result.title.rel"
					  [title]="result.title.title"
					  [modifier]="result.title.modifier"></cov-link>
			<ng-template [ngIf]="result.tags && result.tags.length > 0">
				<cov-tag *ngFor="let tag of result.tags; trackBy: trackPermissionRowBy;" [modifier]="tag.modifier" [class]="tag.class" [icon]="tag.icon" [text]="tag.text"></cov-tag>
			</ng-template>
			<p class="m-search-result-list__description" [innerHTML]="result.description.text | highlight : searchText"></p>
		</div>
	</ng-container>
	<ng-template #noResults>
		<cov-search-no-results
			*ngIf="!hasResults()"
			[noResultsTitle]="noResultsTitle"
			[noResultsText]="noResultsText"
			[showButton]="false">
		</cov-search-no-results>
	</ng-template>
</div>
